import { memo, ReactNode } from "react";
import styles from "src/components/elements/button/RadioButton/styles.module.css";
import utilStyles from "src/styles/utils.module.css";

type Props = {
  isActive: boolean;
  children?: ReactNode;
  labelStyle?: string;
  disabled?: boolean;
  /**
   * @param onPress cannot trigger when isActive true
   */
  onPress?: () => void;
  /**
   * @param onClick can trigger when isActive true
   */
  onClick?: () => void;
};

export const RadioButton = memo(
  ({
    isActive,
    children,
    labelStyle,
    onPress,
    onClick,
    disabled = false,
  }: Props) => {
    const disableStyle = disabled && styles.disableButton;

    return (
      <div className={utilStyles.commonFlexStart}>
        <label
          className={`${utilStyles.commonFlexCenter} ${styles.radioButtonLabel} ${labelStyle} ${disableStyle}`}
        >
          <div className={styles.inputWrap}>
            {isActive && <div className={styles.activeCircle} />}
            <input
              type="radio"
              checked={isActive}
              className={styles.input}
              onChange={onPress}
              onClick={onClick}
              disabled={disabled}
            />
          </div>
          {children}
        </label>
      </div>
    );
  }
);
